import React from "react";
import styles from "./RsvpLive.module.css";
import bgcImage from "../../../../assets/live.png";
import { TextComponent } from "../../../../components";
import { MdFlipCameraAndroid } from "react-icons/md";
import { BsFillMicFill } from "react-icons/bs";
import { AiFillCloseSquare } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { TbRefreshDot } from "react-icons/tb";
import { IoClose } from "react-icons/io5";
import { BiSolidMicrophone, BiSolidMicrophoneOff } from "react-icons/bi";
import { Row } from "antd";
import { useState } from "react";

const RsvpLive = () => {
  const [micOn, setMicOn] = useState(true);
  const navigate = useNavigate();
  const myStyle = {
    backgroundImage: `url(${bgcImage})`,
    backgroundRepeat: "no-repeat",
  };

  return (
    <div className={styles.container}>
      <div className={styles.pinkBg}></div>
      <Row className={styles.textRow}>
        <TextComponent textClass={styles.text}>
          You & 34 Guests Are Watching
        </TextComponent>
      </Row>
      <Row className={styles.iconRow}>
        <TbRefreshDot className={styles.icon} />
        <div
          className={styles.closeIconBtn}
          onClick={() => navigate("/guestHome")}
        >
          <IoClose className={styles.icon} />
        </div>
        {micOn ? (
          <BiSolidMicrophone
            className={styles.icon}
            onClick={() => setMicOn(false)}
          />
        ) : (
          <BiSolidMicrophoneOff
            className={styles.icon}
            onClick={() => setMicOn(true)}
          />
        )}
      </Row>
    </div>
  );
};

export default RsvpLive;
